var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observer } from 'mobx-react';
import customerIdAsKey from './customerIdAsKey';
import React, { Component } from 'react';
import { injectStores } from '../util/StoresUtil';
let HasMandate = class HasMandate extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "mandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        this.mandateStore.loadMandateInfo(this.props.mandates, this.props.matchAll);
    }
    render() {
        const { mandates, matchAll, children, not } = this.props;
        if (this.mandateStore.isFetched(mandates, matchAll) && this.mandateStore.hasMandate(mandates, matchAll) !== !!not) {
            return React.createElement(React.Fragment, null, children);
        }
        return null;
    }
};
HasMandate = __decorate([
    customerIdAsKey,
    injectStores,
    observer
], HasMandate);
export default HasMandate;
